import axios from './../../libs/api.request'

export function home () {
  return axios.request({
    url: '/merchant/home',
    method: 'get'
  })
}

export function switchMerchant (merchantId) {
  return axios.request({
    url: '/merchant/switch?merchantId=' + merchantId,
    method: 'get'
  })
}
export function feedback (data) {
  return axios.request({
    url: '/user/feedback',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/components/home/homeApi.js